var map = {
	"./BuildingTemplate": 45,
	"./CardTemplate": 10,
	"./FloorTemplate": 34,
	"./LandingTemplate": 63,
	"./LoginTemplate": 64,
	"./OnboardBuildingTemplate": 94,
	"./OnboardRoomTemplate": 95,
	"./OnboardUserTemplate": 96,
	"./OrgTemplate": 65,
	"./RequestAccessTemplate": 97,
	"./RoomTemplate": 35,
	"./SettingsTemplate": 40
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;


//////////////////
// WEBPACK FOOTER
// ./src/lib/langTemplates ^\.\/.*Template$
// module id = 525
// module chunks = 1